// Getters
export const boletador = (state) => {
  return state.boletador.data || []
}
export const boletadorLoading = (state) => {
  return state.boletador.loading
}
export const boletadorLastUpdate = (state) => {
  return state.boletador.lastUpdate
}

export const produtos = (state) => {
  return state.produtos.data || []
}
export const produtosLoading = (state) => {
  return state.produtos.loading
}
export const produtosLastUpdate = (state) => {
  return state.produtos.lastUpdate
}

export const clients = (state) => {
  return state.clients.data || []
}
export const clientsLoading = (state) => {
  return state.clients.loading
}
export const clientsLastUpdate = (state) => {
  return state.clients.lastUpdate
}

